import React, { useState, useEffect } from "react";
import axios from "../../api/axios";
import { useNavigate } from "react-router-dom";
import { FaChartBar, FaShoppingCart, FaClipboardList, FaFileAlt } from "react-icons/fa";
import Navbar from '../navsidebar/navbar';
import Sidebar from '../navsidebar/sidebar';

export default function RetailReport() {
  const navigate = useNavigate();
  const [data, setData] = useState(0);


  const { businessEntityId: business_entity_id } = JSON.parse(sessionStorage.getItem("userData"));



  useEffect(() => {
    const fetchReportData = async () => {
      try {
        const response = await axios.get(`retail/getTodayTotalAmount/${business_entity_id}`);
        setData(response.data.total_grand_total);
      } catch (error) {
        console.error("Error fetching report:", error);
      }
    };
    fetchReportData();
  }, []);

  return (
    <div className="d-flex vh-100 bg-light">
      <Sidebar />

      <div className="d-flex flex-column w-100">
        <Navbar />

        <div className="p-4 bg-light min-vh-100">
          {/* Cards Grid */}
          <div className="row g-4">

            {/* Total Sales */}
            <div className="col-12 col-sm-6 col-lg-3">
              <div className="bg-white shadow-lg p-4 rounded text-center h-100 d-flex flex-column align-items-center">
                <FaShoppingCart className="text-primary fs-1 mb-2" />
                <h5 className="fw-semibold">Total Sales</h5>
                <p className="text-muted mb-1">On this day</p>
                <p className="fs-4 fw-bold text-dark">₹{data}</p>
              </div>
            </div>

            {/* Revenue By Category */}
            <div className="col-12 col-sm-6 col-lg-3">
              <div className="bg-white shadow-lg p-4 rounded text-center h-100 d-flex flex-column align-items-center">
                <FaChartBar className="text-success fs-1 mb-2" />
                <h5 className="fw-semibold">Revenue By Category</h5>
                <p className="text-muted">On this day</p>
                <button
                  onClick={() => navigate(`/retail/categorytable`)}
                  className="btn btn-primary rounded-pill mt-2"
                >
                  View Details
                </button>
              </div>
            </div>

            {/* Top Selling Items */}
            <div className="col-12 col-sm-6 col-lg-3">
              <div className="bg-white shadow-lg p-4 rounded text-center h-100 d-flex flex-column align-items-center">
                <FaClipboardList className="text-warning fs-1 mb-2" />
                <h5 className="fw-semibold">Top 20 Selling Items</h5>
                <p className="text-muted">On this day</p>
                <button
                  onClick={() => navigate(`/retail/topitem`)}
                  className="btn btn-primary rounded-pill mt-2"
                >
                  View Details
                </button>
              </div>
            </div>

            {/* Detailed Report */}
            <div className="col-12 col-sm-6 col-lg-3">
              <div className="bg-white shadow-lg p-4 rounded text-center h-100 d-flex flex-column align-items-center">
                <FaFileAlt className="text-purple fs-1 mb-2" />
                <h5 className="fw-semibold">Detailed Report</h5>
                <button
                  onClick={() => navigate(`/retail/detailreport`)}
                  className="btn btn-primary rounded-pill mt-3"
                >
                  View Report
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
